import React, { Component } from 'react';
import * as GServ from '../services/GatewayService';
import { CircularProgress } from '@material-ui/core';

class RedirectPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: true,
            status: "We're busy processing your application, please don't close this page...",
            warning: '',
            mainHeadText: 'Thank You!',
            formDetails: {},
            confirmed: false,
        }
    }
    
    componentDidMount() {
        // console.log('calling fetchAppReceipt...');
        this.fetchAppReceipt();
    }

    render() {
        let missingQparms = false;
        if (!this.props.qparms.token||!this.props.qparms.entry){missingQparms=true}

        return (
            <div style={{maxWidth:900}}>

                {missingQparms&&
                <div>
                    <h3>Technical Error</h3>
                    Unfortunately a technical error was encountered when we tried to process your application.<br/>
                    If this problem persists, please contact us.
                </div>}
                
                {!missingQparms&&
                <div>
                    <h3>{this.state.mainHeadText}</h3>
                    
                    {this.state.confirmed&&this.state.formDetails&&
                    <span>
                        Thank you for submitting an application for our <b>{this.state.formDetails.application_for}</b>. Your submission has been received and will be processed as soon as possible.
                        <br/>
                        <br/>
                        Should you have any questions or if you would like to follow up on your application, please contact us at : 
                        <br/><br/>
                        <a href={'mailto:' + this.state.formDetails.enquiries_mail}>{this.state.formDetails.enquiries_mail}</a>
                        <br/>
                        <br/>
                        <a href={this.state.formDetails.redirect_url} target='_top'>Home</a>
                    </span>}

                    <hr/>
                    
                    {/* <button onClick={this.fetchAppReceipt} >fetchAppReceipt</button> */}

                    <span id="StatusBar" className="StatusBar">
                        {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp;
                        {this.state.status}
                    </span>
                    <span className='warningMessage'>{this.state.warning}</span>
                    <br/>

                </div>}

            </div>
        );
    }

    fetchAppReceipt = () => {
        // console.log('Called fetchAppReceipt');
        GServ.confirmReceipt(this.props.qparms.token,this.props.qparms.entry)
        .then(reply => {
            console.log('fetchAppReceipt reply => ',reply);
            if (reply.Result==='Expired'){
                this.setState({showSpinner:false,mainHeadText:'Expired', status:"This online form has unfortunately expired. An application form is usually valid for 24 hours from when it's first generated. If you'd still like to submit an application, please follow the original links and submit a fresh application.",confirmed:false});
            } else if (reply.Result==='Failed'&&reply.Message!=='Unable to contact Gateway Prime Server'){
                this.setState({showSpinner:false,mainHeadText:'Invalid Link', status:'',warning:"We're unable to process your form currently, as it seems to have been submitted via an invalid or unauthorised link. If this problem persists, please contact us.",confirmed:false});
            } else if (reply.Result==='Server Error'){
                this.setState({showSpinner:false,mainHeadText:'Unable to Verify Submission Status', status:'',warning:"We apologise, but we're not able to verify the submission status of your form at the moment. This might occur if you've already submitted an application, and then try to re-submit after pressing 'back' on your browser. Please refresh this page and try again - if we've already received your application, we'll let you know. If this problem persists, please contact us.",confirmed:false});
            } else if (reply.Message==='Form not open for entry'){
                this.setState({showSpinner:false,mainHeadText:'Submissions are Closed', status:"This online form is not currently open for submissions. Should you have any queries, please don't hesitate to contact us.", warnning:"",confirmed:false});
            } else if (reply.Payload.receipt_status!=='Published')    {
                // console.log("Message wasn't published. fetchAppReceipt reply => ",reply);
                this.setState({showSpinner:false,mainHeadText:'Technical Error', status:'',warning:"We apologise, but we're not able to process your form at the moment due to a technical error. If this problem persists, please contact us.",confirmed:false});
            } else if (reply.Result !=='Success'){
                // console.log('fetchAppReceipt reply: caught unkown failure => ',reply);
                this.setState({showSpinner:false,mainHeadText:'Technical Error', status:"", warning:"We apologise, but we're not able to process your form at the moment due to a technical error. If this problem persists, please contact us.",confirmed:false});
            } else {
                //i.e. Result = Success
                // console.log('Receipt ok');
                // console.log('fetchAppReceipt reply => ',reply);
                this.setState({showSpinner:false,mainHeadText: reply.Payload.form_title + ' submission received.', status:reply.Payload.disclaimer,warning:'',formDetails:reply.Payload, confirmed:true});
            }
        });
    }
    
}

export default RedirectPage;